import { SortOption } from '../models/sort-option.interface';

export const DEFAULT_SORT_OPTIONS: SortOption[] = [
  { name: "Default", key: "" },
  { name: "Alphabetical Order Increasing", key: "label" },
  { name: "Alphabetical Order Decreasing", key: "-label" },
  { name: "Newest Created First", key: "-id" },
  { name: "Oldest Created First", key: "id" },
];
